module.exports = __webpack_public_path__ + "img/suenching_kapelle_raum_2017_ref.84757739.jpg";